export const REVIEW_SESSION_STATUS_NEW = 'new';
export const REVIEW_SESSION_STATUS_COMPLETED = 'completed';
export const REVIEW_SESSION_STATUS_CANCELED = 'canceled';